import {Controller} from "@hotwired/stimulus"
import CameraController from "./camera_controller";

// Connects to data-controller="cctv--nano-cosmos-camera"
export default class extends CameraController {
  static values = {
    name: String,
    id: String,
    streamId: String,
    replyUrl: String
  }

  connect() {
  }

  async buildCameraBlock(camerasContainer) {
    this.container = document.createElement('div');
    this.container.className = 'col my-1';
    this.container.id = 'camera_' + this.idValue.trim();

    let wrapper = document.createElement('div');
    wrapper.className = 'ratio ratio-16x9';

    this.playerElement = document.createElement('div');
    this.playerElement.className = 'card card-body shadow'
    this.playerElement.id = 'player_' + this.idValue.trim()

    let header = document.createElement('div');
    this.headerBuild(header, this.nameValue)

    this.appendReplyBlock(header, this.replyUrlValue)

    this.container.appendChild(header);
    this.container.appendChild(wrapper);

    wrapper.appendChild(this.playerElement);

    camerasContainer.appendChild(this.container);

    this.player = new NanoPlayer(this.playerElement.id);
    this.nanocosmos_setup(this.player)
  }


  nanocosmos_setup(player) {
    player.setup({
      'source': {
        'entries': [{
          'h5live': {
            'rtmp': {
              'url': 'rtmp://bintu-play.nanocosmos.de:1935/play',
              'streamname': this.streamIdValue
            },
            'server': {
              'websocket': 'wss://bintu-h5live.nanocosmos.de:443/h5live/stream/stream.mp4',
              'hls': 'https://bintu-h5live.nanocosmos.de:443/h5live/http/playlist.m3u8',
              'progressive': 'https://bintu-h5live.nanocosmos.de:443/h5live/http/stream.mp4'
            },
          }
        }],
        'options': {
          'adaption': {},
          'switch': {}
        },
        'startIndex': 0,
      },
      'playback': {
        'autoplay': true,
        'automute': true,
        'muted': false,
        'flashplayer': '//demo.nanocosmos.de/nanoplayer/nano.player.swf'
      },
      'style': {
        'width': 'auto',
        'height': 'auto',
        'displayMutedAutoplay': false
      }
    }).then((function (config) {
      this.playerElement.style = "position: ''";
    }).bind(this));

  }

  removeContainerFromDOM() {
    if (!this.container) return

    const parent = this.container.parentNode
    if (parent) parent.removeChild(this.container)

    this.container = null
  }

  disconnect() {
    super.disconnect()
  }
}
